<template>
    <div class="body">
        <p  class="font1" style="padding-top: 8vh;">不断挑战，勇往直前</p>

        <p class="font2" style="padding-top: 4vh;">上半年你在富学宝典上累计考试<a class="font3">{{ ReportData.examTimes }}</a>次</p>
        <p class="font2">其中一次通过考试的课程有<a class="font3">{{ ReportData.coursenumF }}</a>门</p>
        <p class="font2">超越了<a class="font3">{{ ReportData.rate4 }}</a>%的小伙伴！</p>
        <p class="font2" style="padding-top: 1vh;">你今年获得总学分<a class="font3">{{ ReportData.creditvalue}}</a>分</p>

        <div style="width: 90%;height: 28vh;margin: 0 auto;margin-top: 3vh;background-color: rgba(255, 255, 255, 0.5);border-radius: 10px;">
          <v-chart :option="chartOne" autoresize></v-chart>
        </div>
        <p style="padding-top: 3vh;margin: 0;text-align: center;font-size: 18px;">📘 知识之路，从不辜负用心的人</p>
        <p style="margin: 0;text-align: center;font-size: 18px;">💪 每一次挑战，都是走向荣耀的机会</p>
    </div>
</template>
  
<script>
import { use } from 'echarts/core'
import { PieChart} from 'echarts/charts'
import {GridComponent} from 'echarts/components'
import { CanvasRenderer } from 'echarts/renderers'
import VChart, { THEME_KEY } from "vue-echarts"
use([ GridComponent, PieChart, CanvasRenderer])

export default {
    props: ["ReportData"],
    components: {
        VChart
    },
    data() {
        return {
            chartOne:{
                title: {
                    text: "学分来源占比",
                    left: "center",
                    textStyle:{
                        fontSize:13
                    }
                },
                series:[
                    {
                        type:'pie',
                        center: ['52%', '52%'],  
                        radius: '60%', 
                        label: {
							show: true,
							position: 'top',
							formatter: '{b}{c}%',
							color: '#000',  // 标签颜色
							fontSize: 8,   // 标签字体大小
						},
                        data:[],
                    }
                ]
            }
        }
    }, 
    computed:{
        totalScore(){
            const array=JSON.parse(this.ReportData.creditvalueRate)
            // console.log(array)
            const pieChartData = Object.entries(array).filter(([name, value]) => value !== 0).map(([name, value]) => ({
                value: value,
                name: name,
                itemStyle: {
                    color: this.getColorByName(name),
                },
            }));

            this.$set(this.chartOne.series[0], 'data', pieChartData);

            return array;
        }
    },
    methods:{
        getColorByName(name) {
            const colorMap = {
                线下: '#fae6a2',
                讲师: 'rgb(116, 203, 184)',
                富学宝典: '#f5c163',
                // Add more entries as needed
            };
            return colorMap[name] || 'red'; // Default color for unknown names
        },
    },
    created(){
        this.totalScore
    }
}
</script>
  
<style scoped>
.body {
    background: 
                url("../../assets/25March/logo.png") right  top  no-repeat,
                url("../../assets/25May/icon.png") 49% calc(100% + 50px) no-repeat,
                url("../../assets/25June/bg.jpg")  no-repeat;
    background-size:100% 100%, 55%,cover;
    width: 100%;
    height: 100vh;
}
.font1 {
    width: 96%;
    margin: 0 auto;
    text-align: center;
    font-size: 20px;
    color: #26a5e1;
    font-weight: bold;
    font-family: Helvetica, ‘Hiragino Sans GB’, ‘Microsoft Yahei’, ‘微软雅黑’, Arial, sans-serif;
}

.font2 { 
    width: 96%;
    margin: 0 auto;
    text-align: center;
    padding: 0;
    color: #000;
    font-size: 17px;
    font-family: Helvetica, ‘Hiragino Sans GB’, ‘Microsoft Yahei’, ‘微软雅黑’, Arial, sans-serif;
}

.font3 {
    font-size: 20px;
    font-weight: bold;
    color: #64892f;
    text-shadow:  -1px -1px 0 #fff, 1px -1px 0 #fff, -1px 1px 0 #fff, 1px 1px 0 #fff;
    font-family: Helvetica, ‘Hiragino Sans GB’, ‘Microsoft Yahei’, ‘微软雅黑’, Arial, sans-serif;
}
@media screen and (min-width: 786px) {
  .body {
    background: 
                url("../../assets/25June/pcbg.jpg")  no-repeat;
    background-size:cover;
    width: 100%;
    height: 100vh;
  }
  .font2{
    font-size: 19px;
  }
  .font3{
    font-size: 24px;
  }
}
</style>